<script setup lang="ts">
import { onMounted, ref } from "vue";
import type { CmsElementProductSlider } from "@shopware/composables";
import {useCmsElementConfig} from "#imports";
import { computed } from "vue";
import ProductsSlider from "../ProductsSlider.vue"; // Import necessary Vue composition API functions

const props = defineProps<{
  content: CmsElementProductSlider;
  class: any;
  style: any;
}>();
const relatedProducts = ref();

const { getConfigValue } = useCmsElementConfig(props.content);
let productContext = useContext("product");
let product = null;
if (!productContext.value) {
  product = false;
} else {
  product = productContext.value;
}
const title = computed(() => getConfigValue("title"));

onMounted( async ()=> {
  //if(true === false) {
  //  const response = await getProductList(product.categoryIds[0])
  // const elements = response.elements
  //  if (response) {
  //    relatedProducts.value = removeProductById(product.id, elements)
  //  } else {
  //    relatedProducts.value = computed(() => props.content?.data?.products ?? []).value;
  //  }
  // } else {
    relatedProducts.value = computed(() => props.content?.data?.products ?? []).value;
  // }
})

</script>
<template>
  <section v-if="relatedProducts" class="section section-main  section-products section-products--alt"  :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ props.content?.translated?.config?.title?.value ?? '' }}</h2>
      </header><!-- /.section__head -->
      <div class="product-slider">
        <ProductsSlider :slides="relatedProducts" />
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>